<template>
  <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3" :titleMsg4="titleMsg4"></TitleCard>

    <a-card class="all-card-style ">

      <a-form-model ref="ModelForm" :rules="FormRules"  :model="model"  :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }">
        <a-form-model-item prop="cCropIrrigationPlanID" label="灌水计划名称"  class="ant-form-item2">
          <a-select v-model="model.cCropIrrigationPlanID"    class="ant-form-item3"  >
            <a-select-option v-for="(item,index) in cropIrrigationPlanIDSelectItems" :value="item.ID">
              {{item.cTitle}}
            </a-select-option>
          </a-select>
        </a-form-model-item>

          <a-form-model-item prop="cRISID" label="轮灌组编号"  class="ant-form-item2">
            <a-select v-model="model.cRISID"    class="ant-form-item3"  >
              <a-select-option v-for="(item,index) in groupIDSelectItems" :value="item.ID">
                {{item.cCode}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item  prop="cName" label="轮灌计划名称" class="ant-form-item2">
            <a-input v-model="model.cName" placeholder="请输入" :rows="3" />
          </a-form-model-item>
          <a-form-model-item  prop="fArea" label="灌水面积（亩）" class="ant-form-item2">
            <a-input v-model="model.fArea" placeholder="请输入" :rows="3" />
          </a-form-model-item>
          <a-form-model-item  prop="iIrrTime" label="灌水周期（分钟）" class="ant-form-item2">
            <a-input v-model="model.iIrrTime" placeholder="请输入" :rows="3" />
          </a-form-model-item>
          <a-form-model-item  prop="dPlanTime" label="计划开始时间" class="ant-form-item2">
            <a-date-picker v-model="model.dPlanTime" type="time" placeholder="请选择计划开始时间"
                           showTime
              value-format="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss"  />
          </a-form-model-item>






















        <a-form-model-item :wrapper-col="{ span: 12, offset: 2 }">
          <a-button type="primary" html-type="button" @click="SaveForms">
            确定
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>


<script>
  import TitleCard from '@/components/TitleCard.vue'
  import { _getEntPlatFormData,_getAllUser } from '@/common/request'
import moment from 'moment';
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');
  export default {
    name: 'diseaseForm',
    components: {
      TitleCard
    },
    data() {
      return {
        uploadurl:"",
        cDeviceID:"",
        cControllerID:"",
        fileList:[],
        platformSelectItems:[],
        sceneformSelectItems:[],
        controllerIDSelectItems:[],
        cropNameSelectItems:[],
        farmingContentIDSelectItems :[],
        cropGrowthperiodSelectItems:[],
        userSelectItems:[],
        cropIrrigationPlanIDSelectItems:[],
        deviceIDSelectItems:[],
        groupIDSelectItems:[],
        queryPlatformInfo:{
          cEntID:"",
          keyword:""
        },
        cZgTypeID:'',
        iTypeID:3,
        cLandtypeID:'',
        titleMsg1: "生产管理",
        titleMsg2:'轮灌计划',
        titleMsg3:'轮灌计划',
        titleMsg4:'轮灌计划',
        model:{},
        cEntID:"",
        FormRules:{
          cTitle:[
            { required: true, message: '请输入灌水名称', trigger: 'blur' }
          ],
          cCropID: [
            { required: true, message: '请选择作物名称', trigger: 'change' }
          ],
          cCropGrowthPeriodID:[
            { required: true, message: '请选择作物生长期', trigger: 'change' }
          ],

       /*   fArea:[
            { required: true, message: '请输入灌溉面积', trigger: 'blur' }
          ],*/
          dStartDate:[
            { required: true, message: '请选择开始时间', trigger: 'change' }
          ],
          dEndDate:[
            { required: true, message: '请选择结束时间', trigger: 'change' }
          ],

          fQuota:[
            { required: true, message: '请输入灌水定额', trigger: 'blur' }
          ],
          iNum:[
            { required: true, message: '请输入灌水次数', trigger: 'blur' }
          ],
        }
      }
    },
    mounted () {
      let that=this;


      that.queryPlatformInfo.cEntID=that.$store.getters.User.enterprise.ID;
      that.model.cEntID=that.$store.getters.User.enterprise.ID;

      that.getCropIrrigationPlanIDSelectItems();
console.log('that.$route.params.ID aaa',that.$route.params.ID);
      if (that.$route.params.ID){
        that.model.ID=that.$route.params.ID;
        that.HandleDetail();

      }
      else {
        that.iTypeID=that.$route.params.iTypeID
        console.log('  that.iTypeID',  that.iTypeID)
        that.model.cParentID=that.$route.params.cParentID;
      }
      that.model.cSceneID=that.$store.getters.SCene.ID;
      that.model.cSceneName=that.$store.getters.SCene.cSceneName;
      that.getEntPlatFormData()
      that.getAllUser();
      that.getCropNameData();
      that.getFarmingContentIDData();
      that.getWorkOrder();
      that.getCropGrowthperiodSelectItems();
      that.getDeviceIDSelectItems();
      that.getGroupIDSelectItems();
    },

    methods:{
      moment,
      getCurrentData(){
        return new Date().toLocaleDateString();
      },
      async getGroupIDSelectItems(){
        let that=this;
        let res = await this.$http.post('EntRotationalIrrigationSystem/GroupList', {
          cEntID:that.$store.getters.User.enterprise.ID
        });
        that.groupIDSelectItems =res.data.obj.list;
      },
      async getCropIrrigationPlanIDSelectItems(){
        let that=this;
        let res = await this.$http.post('EntWLWCropIrrigationPlan/List', {
          cEntID:that.$store.getters.User.enterprise.ID
        });
        that.cropIrrigationPlanIDSelectItems =res.data.obj.list;
      },
      async getDeviceIDSelectItems(){
        let that=this;
        let res = await this.$http.post('WLWDevice/List', {
          cEntID:that.$store.getters.User.enterprise.ID,cSystemCode:'节水灌溉'
        });
        that.deviceIDSelectItems =res.data.obj.list;
      },
      onCropGrowthPeriodChange(item){

        this.model.CropGrowthPeriodName=this.cropGrowthperiodSelectItems.filter(s=>s.ID==item)[0].cDicName

      },
      onCropIDChange(item){
        this.model.cCropName=this.cropNameSelectItems.filter(s=>s.ID==item)[0].cDicName;
      },
      uploadchange(e){
        console.log('e.file.response.Id',e.file.response.Id);
        let that=this;

        if (e.file){

          that.fileList.push({
            uid:e.file.response.Id,
            name: e.file.response.Id,
            status: 'done',
            response: '', // custom error message to show
            url: that.$http.defaults.baseURL.slice(0,that.$http.defaults.baseURL.length-4)+e.file.response.Id,
          })




        }

      },


      deviceIDSelect(){
        this.getPropertiesW();
      },
      async getPropertiesW(){
        let that=this;
        let res= await that.$http.post ('/WLWProduct/SelAllPropertiesW?cDeviceID='+that.cDeviceID,{});
        if(res.data.code=='200'){
          that.controllerIDSelectItems=res.data.obj.list;
          that.cControllerID= that.cControllerID;

          if(that.controllerIDSelectItems.length>0) {
            //  that.cControllerID=that.controllerIDSelectItems[0].ID

          }


        }
      },
      platformSelect(){

        this.getSceneData()
      },
      async getAllUser(){
        console.log('getAllUser',2222222);
        let that=this
        let res=await _getAllUser(this,this.queryPlatformInfo);
        console.log(res);
        if(res.code=='200'){
          that.userSelectItems=res.obj.list
        }
      },
      async getWorkOrder(){
        var that=this
        let res=await that.$http.post('EntWorkOrderTask/List',{cSystemCode:'节水灌溉'
        })
        if(res.data.code=='200'){
          that.workOrderSelectItems=res.data.obj.list
        }
      },
      /*获取项目列表*/
      async getEntPlatFormData(){
        var that=this
        let res=await  _getEntPlatFormData(this,this.queryPlatformInfo)


        if(res.data.data.code=="200"){

          that.platformSelectItems=res.data.data.obj.list
          if(that.platformSelectItems.length>0) {
            that.model.cPlatformID=that.platformSelectItems[0].ID

            this.getSceneData()
          }
        }

      },
      async getSceneData(){
        var that=this
        let res=await that.$http.post('EntSceneInfo/List',{cSystemCode:'节水灌溉',cPlatformID:that.model.cPlatformID})

        if(res.data.code=="200"){

          that.sceneformSelectItems=res.data.obj.list

          if(that.sceneformSelectItems.length>0) {
            that.model.cSceneID=that.sceneformSelectItems[0].ID
            that.model.cSceneName=that.sceneformSelectItems[0].cSceneName

          }
        }

      },
      async getCropGrowthperiodSelectItems(){
        var that=this
        let param={dicClassCode: 'CropGrowthPeriod'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code=='200'){
          that.cropGrowthperiodSelectItems=res.data.obj.list
        }
      },
      async getCropNameData(){
        var that=this
        let param={dicClassCode: 'CropName'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code=='200'){
          that.cropNameSelectItems=res.data.obj.list
        }

      },
      async getFarmingContentIDData(){
        var that=this

        let param={dicClassCode: 'FarmingContent'};
        let res=await that.$http.post('Dictionary/List',param)
        if(res.data.code='200'){
          that.farmingContentIDSelectItems=res.data.obj.list;
        }


        //  let res=await that.$http.post('FarmingContent/List',{});


      },
      async getKeySecretData(){
        var that=this
        let res=await that.$http.post('HkCamera/GetKeySecretList',{cEntID:that.$store.getters.User.enterprise.ID})

        if(res.data.code=="200"){

          that.AppKeySelectItems=res.data.obj.list

          if(that.AppKeySelectItems.length>0) {
            that.model.AppKey=that.AppKeySelectItems[0].cAppId
            that.model.APPSecret=that.AppKeySelectItems[0].cAppPwd

          }
        }

      },
      sceneformSelect(){
        let that=this;
        that.model.cSceneName=this.sceneformSelectItems.filter(s=>s.ID==that.model.cSceneID)
      },
      async HandleDetail () {
        var that = this;

        let res = await that.$http.post('EntRotationIrrigationPlan/FindById/' + that.model.ID, null)

        if (res.data.code == "200") {
   that.model = res.data.obj.data;
         // that.iTypeID=that.model.iTypeID;
         // that.cZgTypeID=that.model.cZgTypeID;
         // that.cLandtypeID=that.model.cLandtypeID;


         // that.cDeviceID=     that.model.cDeviceID;
        //  that.cControllerID=   that.model.cControllerID;
        //  that.getPropertiesW()
        } else {

        }
        console.log('  that.model ',  that.model );
      },
      async SaveForms () {
        let that = this;
        let form=that.$refs['ModelForm'];
        form.validate(async valid => {



       //   that.model.cSystemCode='节水灌溉';
      //    that.model.cZgTypeID=  that.cZgTypeID;
      //    that.model.iTypeID=that.iTypeID;
      //    that.model.cLandtypeID=that.cLandtypeID;
        //  that.model.cDeviceID=that.cDeviceID;
        //  that.model.cControllerID=that.cControllerID;

          if (valid) {
            //url


            let res = await that.$http.post('EntRotationIrrigationPlan/Save', that.model)
            if (res.data.code == "200") {
              that.$message.success('保存成功!')
              that.$router.push({name:'RotationIrrigationPlanList'});
            } else {
              that.$message.error(res.data.message)

            }
          } else {
            that.$message.error('校验失败!')
          }
        });
      }
    }
  }
</script>

